import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui';
import classNames from 'classnames';

import MainNav from '../MainNav';
import PlayButton from '../PlayButton';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
})

class _LandingVideo extends React.Component {

    static defaultProps = {
        className: ''
    }

    static contextTypes = {
        page: PropTypes.object,
    }

    openPlayer = () => {
        console.log('Clicking')
        if(this.context.page) {
            this.context.page.openPlayer()
        }
    }

    render() {
        const {classes, className} = this.props
        return (
            <div className={classNames(classes.root, className)}>
                <PlayButton onClick={this.openPlayer}/>
                <h2>See how it works</h2>
            </div>
        )
    }
}

export const LandingVideo = withStyles(styles)(_LandingVideo)



// WEBPACK FOOTER //
// ./src/components/landinglib/LandingVideo.jsx